class LoginController {
  /*@ngInject*/
  constructor(Auth, User, $state, $location, $translate, EnvironmentConfigService, Configs, Idle, UserService) {
    this.Auth = Auth
    this.User = User
    this.$state = $state
    this.$location = $location;
    this.EnvironmentConfigService = EnvironmentConfigService;
    this.Configs = Configs;
    this.Idle = Idle;
    this.UserService = UserService;
    this.isLoggedIn = false;
    if (Auth.isAuthenticated()) {
      this.$state.go('home')
    }
    this.$translate = $translate;

    this.name = 'Login'
    this.userCredentials = {
      emailOrUserId: '',
      password: ''
    }

    this.error = ''
    this.appData = '';
    this.model = {
      passwordPolicy: null
    }
  }

  $onInit() {
    this.mobileAppData();
    if (this.Idle.running() && !this.Auth.isAuthenticated()) {
      this.Idle.unwatch()
    }
  }

  mobileAppData() {
    this.EnvironmentConfigService.getUIConfigs()
      .then((data) => {
        this.appData = data.results.mobileAppDownloadLinks;
        const envConfig = data.results.environmentConfig;
        this.Configs.setEnvironmentConfig(envConfig);
      })
      .catch((err) => {
        console.log(err);
      })
  }

  downloadFile() {
    let link = document.createElement("a");
    link.download = "TNTMobile";
    link.href = this.appData.android.downloadLink;
    link.click();
  }

  login() {
    if (!this.isLoggedIn) {
      this.isLoggedIn = true;
      this.error = '';

      this.Auth.login(this.userCredentials).then((data) => {

        if (data && data.message !== 'failed' && !data.validate2FA) {
          this.User.setUser(data);
          const sessionLength = JSON.parse(localStorage.getItem('sessionLength'));
          if (!this.Idle.running() && sessionLength) {
            this.Idle.watch()
          }
          if(sessionLength){
            this.Idle.setIdle(sessionLength * 60);
          }
          this.$translate.use(data.languageId.id || data.languageId);

          let prevStateData = this.User.getPrevState();
          let hasSpecificPrevState = false;
          let prevUrl = '';
          if (prevStateData && prevStateData['hash']) {
            prevUrl = prevStateData['hash'];
            if (prevUrl !== '#/home' && prevUrl !== '/home' && prevUrl !== '#/' && prevUrl !== '/') {
              hasSpecificPrevState = true;
            }
          }

          if (data.customerUser) {
            this.UserService.acl(data.id, data.branchId)
              .then((aclData) => {
                this.User.setACL(aclData);

                let redirectState = null;
                const perMap = this.Auth.permissionMap();

                const findState = (resources, targetResourceName) => {
                  for (const [key, resObj] of Object.entries(resources)) {
                    if (key === targetResourceName) {
                      return resObj.redirectState || resObj.state;
                    }
                    if (resObj.child) {
                      const childState = findState(resObj.child, targetResourceName);
                      if (childState) return childState;
                    }
                  }
                  return null;
                };

                for (const [resName, perms] of Object.entries(aclData)) {
                  if (Array.isArray(perms) && perms.includes('default_redirect')) {
                    const matchedState = findState(perMap, resName);
                    if (matchedState) {
                      redirectState = matchedState;
                      break;
                    }
                  }
                }

                if (!redirectState) {
                  if (hasSpecificPrevState) {
                    this.User.setPrevState('');
                    this.$location.path(prevUrl.substr(2));
                    return;
                  }
                  redirectState = 'app.userProfile';
                }

                let url = this.$state.href(redirectState, { page: 1 });
                if (url && (url.includes('index.html') || url.includes('/v2/'))) {
                  const idx = url.indexOf('/v2/');
                  if (idx !== -1) {
                    url = url.substring(idx);
                  } else {
                    const idx2 = url.indexOf('index.html');
                    if (idx2 !== -1) {
                      url = '/' + url.substring(idx2);
                    }
                  }
                  if (redirectState.startsWith('branchManagement.')) {
                     url = url.replace('#/branch-management/', '#/');
                  }
                  window.open(url, '_self');
                } else {
                  this.$state.go(redirectState, { page: 1 });
                }
              })
              .catch((err) => {
                console.error('Error loading ACL on login:', err);
                if (hasSpecificPrevState) {
                  this.User.setPrevState('');
                  this.$location.path(prevUrl.substr(2));
                } else {
                  this.$state.go('app.userProfile');
                }
              });
          } else if (hasSpecificPrevState) {
            this.User.setPrevState('');
            this.$location.path(prevUrl.substr(2));
          } else {
            this.$state.go('home');
          }
        }
        else if (data && data.message == 'failed') {
          this.model.passwordPolicy = data;
        }
        else if (data.validate2FA) {
          this.$state.go('verify_2FA_code', {
            userId: this.userCredentials.emailOrUserId
          });
        }
        this.isLoggedIn = false;
      }, (err) => {
        this.error = err.data.message;
        this.isLoggedIn = false;
      })
    }
  }
}

export default LoginController;



// WEBPACK FOOTER //
// ./client/app/components/login/login.controller.js